import config from '@app/config';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { BOFAWireFormDetails } from './BOFAWireAfterForm';

export const IPSBOFAWireFormDetails: InstructionFormDetails = {
  ...BOFAWireFormDetails,
  downloadLink: `${config.supplierValidationAttachmentsUrl}IPSBOFAWireTransfer/en/bofa-wire-ips.pdf`,
};
